import { useOrderContext } from "providers/OrderProvider/hooks";
import apolloErrorToSubmissionErrors from "utils/apolloErrorToSubmissionErrors";
import {
  NavigationProp,
  useFocusEffect,
  useNavigation,
} from "@react-navigation/native";
import { SCREENS } from "navigation/consts";
import { EventNavigationParamList } from "navigation/EventNavigation/types";
import { useCallback } from "react";

import { billingValidation } from "./consts";
import { BillingFormProps } from "./partials/BillingForm/types";

export const useBillingForm = (): BillingFormProps => {
  const { order, loading, setOrder } = useOrderContext();
  const { navigate } =
    useNavigation<NavigationProp<EventNavigationParamList>>();

  useFocusEffect(
    useCallback(() => {
      if (!order && !loading) {
        navigate(SCREENS.Cart);
      }
    }, [loading, navigate, order])
  );

  return {
    initialValues: {
      ...order,
    },
    validate: billingValidation.validateForm,
    async onSubmit({
      firstName,
      lastName,
      email,
      customerNotes,
      sendReceipt,
      autoCheckIn,
    }) {
      try {
        await setOrder({
          firstName,
          lastName,
          email,
          customerNotes,
          sendReceipt,
          autoCheckIn,
        });

        navigate(SCREENS.Checkout);

        return undefined;
      } catch (error) {
        return apolloErrorToSubmissionErrors(error);
      }
    },
  };
};
